import React from 'react';
import axios from 'axios';
import { Input, Select, Form, Segment, Button } from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import { Redirect } from 'react-router';
import { DateTimePicker } from 'react-widgets';
import ContractInfo from './ContractInfo';
import { FormattedMessage } from 'react-intl';


axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


class AddNewEmployee extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            person: {},
            allAcademicTitles: [],
            academicTitle: null,

            employeeTypes: [],
            employeeType: null,

            kdo: null,
            workExperience: null,

            workTime: 100,
            dateStart: null,

            showContractInfo: false,
            titleErr: false,

            orgUnitPositions: [],
            orgUnitPosition: null,

            showEmployeeInfo: false,

            associateStatuses: [],
            status: null,

            employer: null,
            comment: null,
            employed: false,

            nonAcademic: false

        };

        this.createEmployee = this.createEmployee.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
    }

    componentDidMount() {
        this.setState({ person: JSON.parse(localStorage.getItem('person')) });


        axios.get('academic-titles', )
            .then(res => {
                this.setState({
                    allAcademicTitles: res.data.filter(e => e.abbreviationSuffix !== '').map(el => ({
                        el, text: el.name + (el.abbreviationPrefix !== '' ? ' ( ' + el.abbreviationPrefix + ' )' : ''), key: el.id, value: el.id

                    }))
                });
            })
            .catch(err => {
                console.log('Failed to fetch academic titles.');
            });

        axios.get('employee-types', )
            .then(res => {
                this.setState({
                    employeeTypes: res.data.map(el => ({
                        ...el, key: el.id, value: el.id, text: el.name
                    }))
                });

                if (localStorage.getItem('academicStaff')) {
                    if (localStorage.getItem('academicStaff') === 'true') this.setState({ employeeType: res.data.find(el => el._key === 'nastavno osoblje').id });
                    if (localStorage.getItem('academicStaff') === 'false') this.setState({ employeeType: res.data.find(el => el._key === 'nenastavno osoblje').id });
                }
            })
            .catch(err => {
                console.log('Failed to fetch academic titles.');
            });

        axios.get('/associate-employee-statuses')
            .then(res => {
                this.setState({
                    associateStatuses: res.data.map(e => ({
                        ...e, key: e.id, value: e.id, text: e.name
                    }))
                });
            })
            .catch(err => {
                console.log('Failed to fetch associate statuses.');
            });

        let obj = { id: null };

        axios.post('hr/positions-by-organizational-unit/', { ...obj })
            .then(res => {
                this.setState({
                    orgUnitPositions: res.data.map(el => ({
                        ...el,
                        value: el.id,
                        key: el.id,
                        text: el.name
                    }))
                });
            })
            .catch(err => {
                console.log('Failed to fetch positions.');
            });
    }


    createEmployee() {
        const {
            kdo, workExperience, academicTitle, dateStart, workTime, employeeType, orgUnitPosition, employeeTypes
        } = this.state;

        const associate = localStorage.getItem('associate') === 'true';
        const employedAssociate = associate && this.state.employed;

        if (!orgUnitPosition || !dateStart || (associate && !this.state.status) ||
            (employedAssociate && !this.state.employer)) {
            toast(<FormattedMessage id="common.requiredFields" />);
            if (!academicTitle) { this.setState({ academicTitleErr: true }); } else { this.setState({ academicTitleErr: false }); }
            if (!orgUnitPosition) { this.setState({ orgUnitPositionErr: true }); } else { this.setState({ orgUnitPositionErr: false }); }
            if (!dateStart) { this.setState({ dateStartErr: true }); } else { this.setState({ dateStartErr: false }); }
            this.setState({
                statusErr: associate && !this.state.status,
                employerErr: employedAssociate && !this.state.employer
            });
        } else if (employeeType === 1 && !academicTitle) {
            toast(<FormattedMessage id="common.requiredFields" />);
            if (!academicTitle) { this.setState({ academicTitleErr: true }); } else { this.setState({ academicTitleErr: false }); }
        } else {
            this.setState({ titleErr: false });

            let academicStaff = null;
            let key = employeeTypes.find(el => el.id === employeeType)._key;
            if (key === 'nastavno osoblje') academicStaff = true;
            if (key === 'nenastavno osoblje') academicStaff = false;

            let obj = {
                employee: {
                    person: { id: this.state.person.id },
                    kdo,
                    workExperience,
                    employeeType: { id: employeeType },
                    academicTitles: academicTitle ? [{
                        academicTitle: { id: academicTitle }
                    }] : [],
                    associateStaff: associate
                },
                organizationalUnitEmployee: {
                    dateStart,
                    main: !associate,
                    workTime
                },
                position: { id: orgUnitPosition },

                associateEmployment: associate ? {
                    employer: employedAssociate ? this.state.employer.trim() : null,
                    comment: this.state.comment,
                    associateEmployeeStatus: { id: this.state.status }
                } : null
            };

            axios.post('hr/employee/basic-info/save/', { ...obj })
                .then(res => {
                    localStorage.setItem('main', 'true');
                    toast('Dodavanje zaposlenika je uspješno izvršeno.');
                    let object = {
                        jmbg: this.state.person.jmbg
                    };
                    axios.post('hr/get-employee-by-jmbg/', { ...object })
                        .then(res => {
                            localStorage.setItem('employee', JSON.stringify(res.data[0]));
                            res.data[0].associateStaff ? localStorage.setItem('associate', 'true') : localStorage.setItem('associate', 'false');

                            if (res.data[0].employeeType._key === 'nastavno osoblje') localStorage.setItem('academicStaff', 'true');
                            if (res.data[0].employeeType._key === 'nenastavno osoblje') localStorage.setItem('academicStaff', 'false');

                            this.setState({ showContractInfo: true });
                        });
                })
                .catch(err => {
                    console.log('Failed to save employment info.');
                    toast('Došlo je do greške! Dodavanje zaposlenika nije uspješno izvršeno.');
                });
        }
    }

    handleInputChange(e, { name, value }) {
        this.setState({ [name]: value });

        if (name === 'employeeType') {
            if (this.state.employeeTypes.find(el => el._key === 'nenastavno osoblje').id === value) {
                this.setState({ academicTitle: null, nonAcademic: true });
            } else this.setState({ nonAcademic: false });
        }

        if (name === 'status') {
            if (this.state.associateStatuses.find(el => el.id === value)._key === 'employed') {
                this.setState({ employed: true });
            } else {
                this.setState({ employed: false });
            }
        }
    }

    handleDateChange(name, date) {
        this.setState({
            [name]: date
        });
    }


    render() {
        if (this.state.showEmployeeInfo) return <Redirect push to={{ pathname: '/pretraga-i-unos-osobe/informacije-o-zaposleniku' }} />;
        return (
            <div>
                <h1>Dodavanje zaposlenika</h1>

                {this.state.showContractInfo ?
                    <ContractInfo
                        showInfo={() => { console.log('Došloo'); this.setState({ showContractInfo: false, showEmployeeInfo: true }); }}
                    />
                    : <Segment.Group raised>
                        <Segment>
                            <h3>{this.state.person.firstName} {this.state.person.lastName}</h3>
                        </Segment>
                        <Segment clearing>
                            <Form>
                                <Form.Group widths="equal">
                                    <Form.Field readOnly disabled={localStorage.getItem('academicStaff') !== 'none'}>
                                        <label>Tip osoblja</label>
                                        <Form.Dropdown
                                            selection
                                            options={this.state.employeeTypes}
                                            onChange={this.handleInputChange}
                                            value={this.state.employeeType}
                                            name="employeeType"
                                            placeholder="Odaberite tip osoblja"
                                            search
                                            fluid
                                        />
                                    </Form.Field>
                                    <Form.Field disabled={localStorage.getItem('academicStaff') === 'false' || this.state.nonAcademic} required error={this.state.academicTitleErr}>
                                        <label>Titula</label>
                                        <Form.Dropdown
                                            selection
                                            options={this.state.allAcademicTitles}
                                            onChange={this.handleInputChange}
                                            value={this.state.academicTitle}
                                            name="academicTitle"
                                            placeholder="Odaberite titulu"
                                            search
                                            fluid
                                        />
                                    </Form.Field>
                                    <Form.Field required error={this.state.orgUnitPositionErr}>
                                        <label>Pozicija</label>
                                        <Form.Dropdown
                                            selection
                                            options={this.state.orgUnitPositions.filter(el => el.employeeType && el.employeeType.id === this.state.employeeType)}
                                            onChange={this.handleInputChange}
                                            value={this.state.orgUnitPosition}
                                            name="orgUnitPosition"
                                            placeholder="Odaberite poziciju"
                                            search
                                            fluid
                                        />
                                    </Form.Field>
                                    <Form.Field required error={this.state.dateStartErr}>
                                        <label>Početak radnog odnosa / angažmana</label>
                                        <DateTimePicker
                                            format="D. M. YYYY."
                                            time={false}
                                            onChange={this.handleDateChange.bind(null, 'dateStart')}
                                            value={this.state.dateStart}
                                        />
                                    </Form.Field>

                                </Form.Group>
                                <Form.Group widths="equal">
                                    <Form.Field
                                        control={Input}
                                        label="Koeficijent dodatka po drugim osnovama"
                                        placeholder="KDO"
                                        value={this.state.kdo}
                                        name="kdo"
                                        type="number"
                                        onChange={this.handleInputChange}
                                    />
                                    <Form.Field
                                        control={Input}
                                        label="Radno iskustvo"
                                        placeholder="Unesite radno iskustvo"
                                        value={this.state.workExperience}
                                        name="workExperience"
                                        type="number"
                                        onChange={this.handleInputChange}
                                    />
                                    <Form.Field>
                                        <label>Radno vrijeme (%)</label>
                                        <input
                                            value={this.state.workTime}
                                            onChange={(e) => this.setState({ workTime: e.target.value })}
                                            name="workTime"
                                            type="number"
                                            placeholder="Unesite radno vrijeme u postotcima"
                                        />
                                    </Form.Field>

                                    {
                                        localStorage.getItem('associate') === 'true' ?
                                            <Form.Field required error={this.state.statusErr}>
                                                <label>Status angažovane osobe</label>
                                                <Form.Dropdown
                                                    selection
                                                    options={this.state.associateStatuses}
                                                    onChange={this.handleInputChange}
                                                    value={this.state.status}
                                                    name="status"
                                                    placeholder="Odaberite status"
                                                    search
                                                    fluid
                                                />
                                            </Form.Field>
                                            : <Form.Field />

                                    }

                                </Form.Group>

                                { localStorage.getItem('associate') === 'true' &&
                                <Form.Group widths="equal">
                                    <Form.Field width="2" disabled={!this.state.employed} required={this.state.employed} error={this.state.employerErr}>
                                        <label>Poslodavac angažovane osobe (naziv institucije)</label>
                                        <input
                                            value={this.state.employer}
                                            onChange={(e) => this.setState({ employer: e.target.value })}
                                            name="employer"
                                            placeholder="Unesite naziv institucije"
                                        />
                                    </Form.Field>
                                    <Form.Field width="2">
                                        <label>Napomena</label>
                                        <input
                                            value={this.state.comment}
                                            onChange={(e) => this.setState({ comment: e.target.value })}
                                            name="comment"
                                            placeholder="Unesite napomenu"
                                        />
                                    </Form.Field>
                                </Form.Group>
                                }
                                <br />
                                <Button color="blue" floated="right" onClick={this.createEmployee}>Dodaj zaposlenika</Button>
                            </Form>
                        </Segment>
                    </Segment.Group>}
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}

export default AddNewEmployee;



// WEBPACK FOOTER //
// ./src/views/HR/add/AddNewEmployee.js